import createIcon from '../../createIcon';

/**
 * @component @name Eject
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxN0gxOVYxOUg1VjE3Wk0xMiA1TDUuMzMgMTVIMTguNjdMMTIgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Eject = createIcon('Eject', [
  ['path', { d: 'M5 17H19V19H5V17ZM12 5L5.33 15H18.67L12 5Z', key: 'o4pnud' }],
]);

export default Eject;
